/**
 * Request hook of the API client: Laravel Sanctum cookie authentication.
 *
 * The session cookie travels on its own (`credentials: 'include'`), but the
 * CSRF token must be echoed: Sanctum sets the `XSRF-TOKEN` cookie
 * (`GET /sanctum/csrf-cookie`) and expects it back in `X-XSRF-TOKEN` on every
 * state-changing request. axios did that by itself; ofetch does not.
 *
 * Moving to Passport later only changes this hook (send `Authorization:
 * Bearer`) and the login/logout actions.
 */
const SAFE_METHODS = ['GET', 'HEAD', 'OPTIONS']

export function readCookie(name: string): string | null {
  const prefix = `${name}=`
  const cookie = document.cookie
    .split('; ')
    .find((entry) => entry.startsWith(prefix))

  return cookie ? decodeURIComponent(cookie.slice(prefix.length)) : null
}

export function authorizeRequest(config: {
  method?: string
  headers: Record<string, string>
}): void {
  config.headers.Accept ??= 'application/json'
  config.headers['X-Requested-With'] ??= 'XMLHttpRequest'

  if (SAFE_METHODS.includes((config.method ?? 'GET').toUpperCase())) {
    return
  }

  const xsrfToken = readCookie('XSRF-TOKEN')
  if (xsrfToken) {
    config.headers['X-XSRF-TOKEN'] = xsrfToken
  }
}
